import React from 'react';

interface SergicLogoProps {
  className?: string;
}

const SergicLogo: React.FC<SergicLogoProps> = ({ className = "h-8" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/logo-couleurs-RVB-1.svg" 
        alt="SERGIC Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default SergicLogo;
